// extracted by mini-css-extract-plugin
export default {"root":"DeletionWarning_root__pfuU5","listTitle":"DeletionWarning_listTitle__R2o75","placeHolderShimmer":"DeletionWarning_placeHolderShimmer__+LSCf"};